<div [class.container]="isInquiries">
  <div>
    <button mat-button type="button" (click)="addRow($event)">
      <mat-icon>{{ isOrders ? 'add_box_outline' : 'help' }}</mat-icon>
      <span>{{ isOrders ? 'ADD ORDER' : 'ADD INQUIRY' }}</span>
    </button>
  </div>
  <div *ngIf="isOrders && !host.loaded">
    <h3 style="text-align:center;">LOADING ORDERS</h3>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
  <div style="width:100%" [formGroup]="host.orderForm" *ngIf="!isOrders || host.loaded">
    <mat-table #table [dataSource]="host.dataSource" matSort [matSortActive]="isInquiries ? 'vendor' : ''"
      [matSortDirection]="isInquiries ? 'asc' : ''" class="mat-elevation-z2" formArrayName="orders" multiTemplateDataRows>

      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef fxFlex="1 1 196px"> STATUS </mat-header-cell>
        <mat-cell *matCellDef="let order; let i=dataIndex; let row;" fxFlex="1 1 196px">
          <ng-container *ngIf="order.value.products[0].product.vendor">
            <button *ngIf="order.value.products && order.value.products.length>0 && host.orderStatus.indexOf(order.value.status)!=-1" mat-button (click)="host.clickButton($event, order, i)" [routerLink]="['/admin/managed-board', { outlets: { sub: ['stack', order.value.products[0].product.vendor._id] } }]" style="width:300px;">{{ order.value.status }}</button>
            <button *ngIf="order.value.products.length>0 && host.awaitingStatus.indexOf(order.value.status)!=-1" mat-button (click)="host.clickButton($event, order, i)" [routerLink]="['/admin/managed-board', { outlets: { sub: ['awaiting-frames', order.value.products[0].product.vendor._id] } }]" style="width:300px;">{{ order.value.status }}</button>
            <button
              *ngIf="order.value.products.length>0 && host.awaitingStatus.indexOf(order.value.status)==-1 && host.orderStatus.indexOf(order.value.status)==-1 && order.value.status !== 'QUOTE' && order.value.status !== 'HOLD/RX' && order.value.status !== 'CALL FOR RX'"
              mat-button
              (click)="host.clickButton($event, order, i)"
              [routerLink]="['/admin/managed-board', { outlets: { sub: ['awaiting-frames', order.value.products[0].product.vendor._id] } }]" style="width:300px;">{{ order.value.status }}</button>
          </ng-container>
          <span *ngIf="!order.value.products[0].product.vendor || order.value.status === 'QUOTE' || order.value.status === 'HOLD/RX' || order.value.status === 'CALL FOR RX'">{{ order.value.status }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="alert">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 40px"> </mat-header-cell>
        <mat-cell *matCellDef="let order; let i=dataIndex; let row;" fxFlex="0 0 40px">
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="vendor">
        <mat-header-cell *matHeaderCellDef [fxFlex]="isOrders ? '1 1 230px' : '1 1 220px'"> VENDOR </mat-header-cell>
        <mat-cell *matCellDef="let order; let i=dataIndex" [formGroupName]="i" [class.product-cell]="isInquiries" [fxFlex]="isOrders ? '1 1 230px' : '1 1 220px'">
          <span *ngIf="host.orderId!=order.value._id && order.value.products[0] && order.value.products[0].product.vendor"> {{ order.value.products[0].product.vendor.name }} </span>
          <app-autocomplete-vendors placeholder="VENDOR" *ngIf="host.orderId==order.value._id"
            [(productForm)]="order.controls.products['controls'][0]['controls']['product']" [(fieldOpen)]="host.fieldOpen"
            [fxFlex]="isOrders ? '1 1 90%' : '1 1 190px'"></app-autocomplete-vendors>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="model">
        <mat-header-cell *matHeaderCellDef mat-sort-header [fxFlex]="isOrders ? '1 1 15%' : '1 1 10%'"> MODEL </mat-header-cell>
        <mat-cell *matCellDef="let order; let i=dataIndex; let row;" [fxFlex]="isOrders ? '1 1 15%' : '1 1 10%'" [formGroupName]="i">
          <span *ngIf="host.orderId!=order.value._id">{{order.value.products[0].product.model}}</span>
          <app-autocomplete-vendor-products [(productForm)]="order.controls.products['controls'][0]['controls']['product']"
            [vendor]="order.value.products[0].product.vendor"
            placeholder="MODEL"
            *ngIf="host.orderId==order.value._id"
            (selected)="host.updateProduct($event,order,i)"
            [(fieldOpen)]="host.fieldOpen"
            displayField="model"
            [fxFlex]="isOrders ? '1 1 90%' : null">
          </app-autocomplete-vendor-products>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="color">
        <ng-container *ngIf="isInquiries">
          <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="1 1 8%"> COLOR </mat-header-cell>
        </ng-container>
        <ng-container *ngIf="isOrders">
          <mat-header-cell *matHeaderCellDef fxFlex="1 1 10%"> COLOR </mat-header-cell>
        </ng-container>
        <mat-cell *matCellDef="let order; let i=dataIndex; let row;" [fxFlex]="isOrders ? '1 1 10%' : '1 1 8%'" [formGroupName]="i">
          <span *ngIf="host.orderId!=order.value._id">{{order.value.products[0].product.color}}</span>
          <app-autocomplete-vendor-products [(productForm)]="order.controls.products['controls'][0]['controls']['product']"
            [vendor]="order.value.products[0].product.vendor"
            placeholder="COLOR"
            *ngIf="host.orderId==order.value._id"
            (selected)="host.updateProduct($event,order,i)"
            [(fieldOpen)]="host.fieldOpen"
            displayField="color"
            [fxFlex]="isOrders ? '1 1 90%' : null">
          </app-autocomplete-vendor-products>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="size">
        <ng-container *ngIf="isInquiries">
          <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 50px"> SIZE </mat-header-cell>
        </ng-container>
        <ng-container *ngIf="isOrders">
          <mat-header-cell *matHeaderCellDef fxFlex="0 0 50px"> SIZE </mat-header-cell>
        </ng-container>
        <mat-cell *matCellDef="let order; let i=dataIndex; let row;" fxFlex="0 0 50px" [formGroupName]="i">
          <span *ngIf="host.orderId!=order.value._id"> {{order.value.products[0].product.size}} </span>
          <app-autocomplete-vendor-products [(productForm)]="order.controls.products['controls'][0]['controls']['product']"
            [vendor]="order.value.products[0].product.vendor"
            placeholder="SIZE"
            *ngIf="host.orderId==order.value._id"
            (selected)="host.updateProduct($event,order,i)"
            [(fieldOpen)]="host.fieldOpen"
            displayField="size">
          </app-autocomplete-vendor-products>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="type">
        <ng-container *ngIf="isInquiries">
          <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 60px"> TYPE </mat-header-cell>
        </ng-container>
        <ng-container *ngIf="isOrders">
          <mat-header-cell *matHeaderCellDef fxFlex="0 0 60px"> TYPE </mat-header-cell>
        </ng-container>
        <mat-cell *matCellDef="let order; let i=dataIndex; let row;" fxFlex="0 0 60px" [formGroupName]="i">
          <span *ngIf="host.orderId!=order.value._id && order.value._id!=''">{{order.value.products[0].type}}</span>
          <ng-container formGroupName="products">
            <ng-container [formGroupName]="0">
              <mat-form-field *ngIf="host.orderId==order.value._id || order.value._id==''" floatLabel="never" style="width:90%">
                <mat-select #formRow placeholder="TYPE" formControlName="type" (click)="host.clickField2($event, order, i);$event.stopPropagation();" (selectionChange)="host.changeProductType($event,order)">
                  <mat-option *ngFor="let typeOption of host.productTypeOptions" [value]="typeOption.value">
                    {{typeOption.viewValue}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>
          </ng-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="invoiceNumber">
        <mat-header-cell *matHeaderCellDef fxFlex="1 1 110px"> INVOICE # </mat-header-cell>
        <mat-cell *matCellDef="let order; let i=dataIndex; let row;" fxFlex="1 1 110px" [formGroupName]="i">
          <span *ngIf="host.orderId!=order.value._id && order.value.status === 'QUOTE'">QUOTE</span>
          <span *ngIf="host.orderId!=order.value._id && order.value.status !== 'QUOTE' && order.value.invoiceNumber" [class.priority-redo-invoice]="order.value.redoPriority">{{order.value.type}}&nbsp;&ndash;&nbsp;{{order.value.invoiceNumber }}<span class="fulfillment-ship-badge" *ngIf="order.value.fulfillment === 'SHIP' && order.value.status !== 'DISPENSED'">SHIP</span> </span>
          <mat-form-field *ngIf="host.orderId==order.value._id" floatLabel="always">
            <mat-select placeholder="TYPE" formControlName="type" style="width:30px;" (click)="host.clickField2($event, order, i);" (selectionChange)="host.clickField2($event, order, i)">
              <mat-option *ngFor="let orderTypeOption of host.orderTypeOptions" [value]="orderTypeOption.value">
                {{ orderTypeOption.viewValue }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field *ngIf="host.orderId==order.value._id" >
            <input matInput placeholder="INVOICE #" formControlName="invoiceNumber" (click)="host.clickField2($event,order, i)">
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef fxFlex="1 1 120px"> DATE </mat-header-cell>
        <mat-cell *matCellDef="let order; let i=dataIndex; let row;" fxFlex="1 1 120px" [formGroupName]="i">
          <span *ngIf="host.orderId!=order.value._id"> {{ order.value.date | date:'M/d/yyyy': 'GMT' }} </span>
          <mat-form-field *ngIf="host.orderId==order.value._id" floatLabel="never" style="width:90%">
            <input #formRow [matDatepicker]="picker" matInput placeholder="DATE" type="text" formControlName="date" (dateChange)="host.clickDate($event,order,i)">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="todo">
        <mat-header-cell *matHeaderCellDef fxFlex="0 0 175px"> TO DO </mat-header-cell>
        <mat-cell *matCellDef="let order; let i=dataIndex; let row;" [formGroupName]="i" fxFlex="0 0 175px">
          <span *ngIf="host.orderId!=order.value._id" [ngStyle]="{'text-decoration' : order.status === 'AWAITING FRAME' ? 'line-through' : 'inherit' }">
            <button
              *ngIf="order.value.products[0].product.vendor"
              mat-button type="button"
              (click)="host.clickButton($event, order, host.orderIndex)"
              [routerLink]="['/admin/managed-board', { outlets: { sub: ['stack', order.value.products[0].product.vendor._id] } }]"
              style="width:90%;">
              {{ order.value.todo }}
            </button>
          </span>
          <mat-form-field *ngIf="host.orderId==order.value._id" floatLabel="never" style="width:90%">
            <mat-select placeholder="TO DO" formControlName="todo" (click)="host.clickField2($event, order, host.orderIndex)">
              <mat-option *ngFor="let todoOption of host.todoOptions" [value]="todoOption.value" (click)="host.clickField2($event,order, host.orderIndex)">
                {{ todoOption.viewValue }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="notify">
        <mat-header-cell *matHeaderCellDef fxFlex="0 0 50px"> NOT. </mat-header-cell>
        <mat-cell *matCellDef="let order; let i=dataIndex;" [formGroupName]="i" fxFlex="0 0 50px">
          <mat-checkbox (click)="host.toggleNotify($event,order, host.orderIndex)" formControlName="notify">
          </mat-checkbox>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="view">
        <mat-header-cell *matHeaderCellDef fxFlex="0 0 40px"></mat-header-cell>
        <mat-cell *matCellDef="let order; let i=dataIndex;" fxFlex="0 0 40px" class="stack-view-cell">
          <button
            mat-icon-button
            type="button"
            class="stack-view-order-button"
            (click)="openOrderEdit($event, order)"
            aria-label="View order"
          >
            <mat-icon>visibility</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="image">
        <mat-header-cell *matHeaderCellDef fxFlex="0 0 50px"></mat-header-cell>
        <mat-cell *matCellDef="let order; let i=dataIndex; let row;" fxFlex="0 0 50px">
          <button mat-button (click)="host.openImage(order.value.images[0]); $event.stopPropagation()" *ngIf="order.value.images?.[0]">
            <mat-icon>image</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="action">
        <ng-container *ngIf="isInquiries">
          <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 200px"></mat-header-cell>
        </ng-container>
        <ng-container *ngIf="isOrders">
          <mat-header-cell *matHeaderCellDef fxFlex="0 0 90px"> ACTION </mat-header-cell>
        </ng-container>
        <mat-cell *matCellDef="let order; let i=dataIndex; let row;" [fxFlex]="isOrders ? '0 0 90px' : '0 0 200px'" [formGroupName]="i">
          <ng-container *ngIf="isOrders">
            <mat-form-field style="width:35px;flex: 0 1 35px;" floatLabel="never">
              <input matInput required placeholder="" type="text" formControlName="initials" (click)="$event.stopPropagation()">
              <mat-label><mat-icon>gesture</mat-icon></mat-label>
            </mat-form-field>
            <button mat-button [matMenuTriggerFor]="menu" class="small"><mat-icon>more_vert</mat-icon></button>
            <mat-menu #menu="matMenu">
              <ng-container *ngIf="order.value.status === 'DISPENSED'; else historyDefaultActions">
                <button mat-menu-item type="button" (click)="host.startDuplicate(order); $event.stopPropagation()">
                  DUPLICATE
                </button>
                <button mat-menu-item type="button" [disabled]="order.value.initials==''" (click)="host.exchangeOrder(order);$event.stopPropagation()">
                  EXCHANGE
                </button>
                <button mat-menu-item type="button" (click)="host.startNewRx(order); $event.stopPropagation()">
                  NEW RX
                </button>
                <button mat-menu-item type="button" (click)="host.startRedo(order); $event.stopPropagation()">
                  RE-DO
                </button>
                <button mat-menu-item type="button" (click)="host.startRepair(order); $event.stopPropagation()">
                  REPAIR
                </button>
                <button mat-menu-item type="button" [disabled]="order.value.initials==''" (click)="host.returnOrder(order);$event.stopPropagation()">
                  RETURN
                </button>
                <button mat-menu-item type="button" (click)="host.printImage(order.value.images);">
                  PRINT
                </button>
                <button mat-menu-item type="button" (click)="host.emailOrder(order); $event.stopPropagation()">
                  EMAIL
                </button>
                <button *ngIf="host.isAdminUser" mat-menu-item type="button" (click)="host.deleteOrder(order,i);$event.stopPropagation()">
                  DELETE
                </button>
              </ng-container>
              <ng-template #historyDefaultActions>
                <button mat-menu-item type="button" aria-label="PRINT" (click)="host.printImage(order.value.images);">
                  <mat-icon>print</mat-icon>
                  PRINT
                </button>
                <button mat-menu-item type="button" (click)="host.emailOrder(order); $event.stopPropagation()">
                  <mat-icon>email</mat-icon>
                  EMAIL
                </button>
                <button mat-menu-item type="button" [disabled]="order.value.initials=='' || order.value.status == 'RETURNED'" (click)="host.returnOrder(order);$event.stopPropagation()">
                  <mat-icon>undo</mat-icon>
                  RETURN
                </button>
                <button mat-menu-item type="button" [disabled]="order.value.initials=='' || order.value.status == 'EXCHANGED'" (click)="host.exchangeOrder(order);$event.stopPropagation()">
                  <mat-icon>undo</mat-icon>
                  EXCHANGE
                </button>
                <button *ngIf="host.isAdminUser" mat-menu-item type="button" [disabled]="order.value.initials==''" (click)="host.deleteOrder(order,i);$event.stopPropagation()">
                  <mat-icon>delete</mat-icon>
                  DELETE
                </button>
              </ng-template>
            </mat-menu>
          </ng-container>
          <ng-container *ngIf="isInquiries">
            <mat-form-field style="width:35px;flex: 0 1 35px;padding-left:10px;" floatLabel="never">
              <input matInput required placeholder="" type="text" formControlName="initials" (click)="$event.stopPropagation()">
              <mat-label><mat-icon>gesture</mat-icon></mat-label>
            </mat-form-field>
            <button mat-button (click)="host.clickSaveOrder(order)" [disabled]="order.controls.initials.invalid || !order.value.products[0].product.vendor"><mat-icon>save_box_outline</mat-icon>TO ORDER</button>
          </ng-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="log">
        <ng-container *ngIf="isInquiries">
          <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 300px"> LOG </mat-header-cell>
        </ng-container>
        <ng-container *ngIf="isOrders">
          <mat-header-cell *matHeaderCellDef fxFlex="1 1 300px"> LOG </mat-header-cell>
        </ng-container>
        <mat-cell *matCellDef="let order; let i=dataIndex; let row;" [fxFlex]="isOrders ? '1 1 300px' : '0 0 300px'" [formGroupName]="i" [class.log-cell-start]="isOrders">
          <app-log-menu [order]="order" (clickField)="host.clickField2($event,order,i)"></app-log-menu>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <mat-cell *matCellDef="let order2; let orderIndex=dataIndex;" [formGroupName]="orderIndex" class="expandedCell">
          <div class="example-element-detail" style="width:100%" [class.mat-elevation-z0]="order2!=host.expandedElement" [class.mat-elevation-z8]="order2==host.expandedElement" [@detailExpand]="order2 == host.expandedElement ? 'expanded' : 'collapsed'">
            <mat-table #table [dataSource]="host.dataSource2[orderIndex]" class="mat-elevation-z2">

              <ng-container matColumnDef="notes">
                <mat-header-cell *matHeaderCellDef [fxFlex]="isOrders ? '1 1 50%' : '1 1 90%'"> NOTES </mat-header-cell>
                <mat-cell *matCellDef="let order; let i=index; let row;" [fxFlex]="isOrders ? '1 1 50%' : '1 1 90%'">
                  <span *ngIf="host.orderId!=order.value._id">{{ order.value.notes }}</span>
                  <mat-form-field *ngIf="host.orderId==order.value._id" style="width:100%;padding-left:10px;padding-right:10px;" floatLabel="never">
                    <input matInput placeholder="NOTES" formControlName="notes" (click)="host.clickField2($event, order, orderIndex)">
                  </mat-form-field>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="part">
                <mat-header-cell *matHeaderCellDef fxFlex="0 0 60px"> PART </mat-header-cell>
                <mat-cell *matCellDef="let order; let i=index" class="duty" fxFlex="0 0 60px">
                  <mat-checkbox formControlName="part" (click)="host.clickField2($event,order2,orderIndex)" (change)="host.clickPart($event,order2,orderIndex)"></mat-checkbox>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="specialOrder">
                <mat-header-cell *matHeaderCellDef fxFlex="0 0 80px"> SPC. ORD. </mat-header-cell>
                <mat-cell *matCellDef="let order; let i=index" class="duty" fxFlex="0 0 80px">
                  <mat-checkbox formControlName="specialOrder" (click)="host.clickField2($event,order2,orderIndex)"></mat-checkbox>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="warranty">
                <mat-header-cell *matHeaderCellDef fxFlex="0 0 80px"> WARRANTY </mat-header-cell>
                <mat-cell *matCellDef="let order; let i=index" class="duty" fxFlex="0 0 80px">
                  <mat-checkbox formControlName="warranty" (click)="host.clickField2($event,order2,orderIndex)"></mat-checkbox>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="cost">
                <mat-header-cell *matHeaderCellDef fxFlex="0 1 60px"> COST </mat-header-cell>
                <mat-cell *matCellDef="let order; let i=index; let row;" fxFlex="0 1 60px">
                  <span *ngIf="host.orderId!=order.value._id || (!host.authorized && order.value.products[0].product._id)">{{order.value.products[0].cost | currency : 'USD' : 'symbol' : '1.0' }}</span>
                  <ng-container formGroupName="products">
                    <ng-container [formGroupName]="0">
                      <mat-form-field *ngIf="host.orderId==order.value._id && (host.authorized || !order.value.products[0].product._id)" floatLabel="never">
                        <input #formRow matInput placeholder="COST" type="text" formControlName="cost" (keyup)="host.changeCost(order)">
                      </mat-form-field>
                    </ng-container>
                  </ng-container>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="priceLink">
                <mat-header-cell *matHeaderCellDef fxFlex="0 0 35px">  </mat-header-cell>
                <mat-cell *matCellDef="let order; let i=index;" fxFlex="0 0 35px">
                  <mat-icon (click)="host.togglePriceLink($event,order)" *ngIf="order.value.products[0].pricingFormula!='c'">link_outline</mat-icon>
                  <mat-icon (click)="host.togglePriceLink($event,order)" *ngIf="order.value.products[0].pricingFormula=='c'" color="warn">link_off_outline</mat-icon>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="retail">
                <mat-header-cell *matHeaderCellDef fxFlex="0 1 60px"> RETAIL </mat-header-cell>
                <mat-cell *matCellDef="let order; let i=index; let row;" fxFlex="0 1 60px">
                  <span *ngIf="host.orderId!=order.value._id || (!host.authorized && order.value.products[0].product._id)">
                    {{order.value.products[0].retail | currency : 'USD' : 'symbol' : '1.0' }}
                  </span>
                  <ng-container formGroupName="products">
                    <ng-container [formGroupName]="0">
                      <mat-form-field *ngIf="host.orderId==order.value._id && (host.authorized || !order.value.products[0].product._id)" floatLabel="never">
                        <input #formRow matInput placeholder="RETAIL" type="text" formControlName="retail" (keyup)="host.changeRetail(order)">
                      </mat-form-field>
                    </ng-container>
                  </ng-container>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="duty">
                <mat-header-cell *matHeaderCellDef fxFlex="0 0 60px"> DUTY </mat-header-cell>
                <mat-cell *matCellDef="let order; let i=index" class="duty" fxFlex="0 0 60px">
                  <ng-container formGroupName="products">
                    <ng-container [formGroupName]="0">
                      <mat-checkbox formControlName="duty" (click)="host.toggleDuty($event,order2,orderIndex)"></mat-checkbox>
                    </ng-container>
                  </ng-container>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="retailPlusDuty">
                <mat-header-cell *matHeaderCellDef fxFlex="0 0 60px"> RETAIL + DUTY </mat-header-cell>
                <mat-cell *matCellDef="let order; let i=index" class="duty" fxFlex="0 0 60px">
                  {{ host.settingsService.getRetailPlusDuty(order.value.products[0].retail) | currency : 'USD' : 'symbol' : '1.0' }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="action">
                <ng-container *ngIf="isInquiries">
                  <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 220px"></mat-header-cell>
                </ng-container>
                <ng-container *ngIf="isOrders">
                  <mat-header-cell *matHeaderCellDef fxFlex="0 0 150px"></mat-header-cell>
                </ng-container>
                <mat-cell *matCellDef="let order; let i=index;" [fxFlex]="isOrders ? '0 0 150px' : '0 0 220px'">
                  <mat-form-field style="width:35px;flex: 0 1 35px;padding-left:10px;" floatLabel="never">
                    <input matInput required placeholder="" type="text" formControlName="initials" (click)="$event.stopPropagation()">
                    <mat-label><mat-icon>gesture</mat-icon></mat-label>
                  </mat-form-field>
                  <ng-container *ngIf="isOrders">
                    <button mat-button [matMenuTriggerFor]="saveMenu" (menuClosed)="host.clickField2($event, order, orderIndex)"><mat-icon>more_vert</mat-icon><span>SAVE</span></button>
                    <mat-menu #saveMenu="matMenu">
                      <button mat-menu-item type="button" (click)="host.clickSaveOrder(order,'ORDERED',i)" *ngIf="order.value.type!='F'" style="margin-left:10px;" [disabled]="order.controls.initials.invalid || order.controls.invoiceNumber.invalid">ORDERED FRAME</button>
                      <button mat-menu-item type="button" (click)="host.clickSaveOrder(order,'ORDERED PART',i)" *ngIf="order.value.type=='F'" style="margin-left:10px;" [disabled]="order.controls.initials.invalid || order.controls.invoiceNumber.invalid">ORDERED PART</button>
                      <button mat-menu-item type="button" (click)="host.clickSaveOrder(order,'ORDERED ON APPROVAL',i)" *ngIf="order.value.type!='F'" style="margin-left:10px;" [disabled]="order.controls.initials.invalid || order.controls.invoiceNumber.invalid">ORDERED ON APPROVAL</button>
                      <button mat-menu-item type="button" (click)="host.clickSaveOrder(order,'SEND TO STACK',i)" style="margin-left:10px;" [disabled]="order.controls.initials.invalid || order.controls.invoiceNumber.invalid">TO ORDER</button>
                      <button mat-menu-item type="button" (click)="host.clickSaveOrder(order,'SAVE',i)" style="margin-left:10px;" [disabled]="order.controls.initials.invalid || order.controls.invoiceNumber.invalid || order.value._id==''">SAVE</button>
                      <button mat-menu-item type="button" (click)="host.clickSaveOrder(order,'ORDERED PART',i)" *ngIf="order.value.type=='F'" style="margin-left:10px;" [disabled]="order.controls.initials.invalid || order.controls.invoiceNumber.invalid">SENT OUT</button>
                      <button mat-menu-item type="button" (click)="host.clickSaveOrder(order,'ORDERED ACCESSORY',i)" *ngIf="order.value.type=='A'" style="margin-left:10px;" [disabled]="order.controls.initials.invalid || order.controls.invoiceNumber.invalid">ORDERED ACCESSORY</button>
                      <button mat-menu-item type="button" (click)="host.clickSaveOrder(order,'ADDED TO INVENTORY',i)" *ngIf="order.value.specialOrder" style="margin-left:10px;" [disabled]="order.controls.initials.invalid">ADD TO INVENTORY</button>
                    </mat-menu>
                  </ng-container>
                  <button *ngIf="isInquiries" mat-button (click)="host.clickSaveOrder(order)" [disabled]="order.controls.initials.invalid || !order.value.products[0].product.vendor"><mat-icon>save_box_outline</mat-icon>TO ORDER</button>
                </mat-cell>
              </ng-container>

              <ng-container *ngIf="isOrders">
                <mat-header-row *matHeaderRowDef="expandedColumns(order2)" fxLayout="row"
                  fxLayoutAlign="start center">
                </mat-header-row>
              </ng-container>
              <mat-row *matRowDef="let row; columns: expandedColumns(order2); let i=index; let even=even; let odd=odd;" fxLayout="row"
                [fxLayoutAlign]="isOrders ? 'start center' : 'space-between center'" appHighlight [ngClass]="{rowEven:even, rowOdd:odd}" style="border-left:1px solid #dfdfdf !important;"
                (click)="host.clickOrder($event, row, orderIndex)">
              </mat-row>
            </mat-table>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="host.displayedColumns" fxLayout="row"
        fxLayoutAlign="start center">
      </mat-header-row>
      <mat-row *matRowDef="let row; columns: host.displayedColumns; let i=dataIndex; let even=even; let odd=odd;" fxLayout="row" fxLayoutAlign="start center"
        [ngClass]="{rowEven:i%2, rowOdd:(i+1)%2}" style="border-left:1px solid #dfdfdf !important;"
        (click)="onRowClick($event, row, i)">
      </mat-row>
      <mat-row *matRowDef="let element; columns: ['expandedDetail']"
        [class.example-detail-row-expanded]="host.expandedElement === element"
        [class.example-detail-row-collapsed]="host.expandedElement !== element"
        style="overflow: hidden"
        fxLayoutAlign="start center">
      </mat-row>
    </mat-table>
  </div>
</div>
